import React from 'react'
import Dashboard from './Dashboard'


const MainDashboard = () => {
  return (
    <div>
 <Dashboard />
    </div>
  )
}

export default MainDashboard
